module.exports = __webpack_public_path__ + "media/2.2_super_adjectives_tarjeta_avatar_house_cf1.f928d39a.wav";